export default __webpack_public_path__ + "assets/images/2491d7b79ed493c019dcbdbf383c728f.png";